import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useSmartGuides } from '../../context';
import { PrintableBody1 } from '../../printable-styles/printable-typography';
import { MediaType } from '../../types/Media';
import { TableContentType } from '../../types/Table';
import { Media } from '../Media';
import { PreprInnerHtml } from '../PreprInnerHtml';
import { Table } from '../Table';

const StyledManagementComment = styled(PrintableBody1)`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) =>
    theme.tokens.color.alias.cm.surface['surface-secondary'].value};
  gap: 8px;
  padding: 12px 16px;
  border-radius: 4px;
  color: ${({ theme }) => theme.tokens.color.alias.cm.text.text.value};

  > div {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  @media print {
    padding: 8px;

    ${({ hasBreakPage }: { hasBreakPage: boolean }) =>
      hasBreakPage &&
      css`
        break-inside: avoid;
      `}
  }
`;

type Props = {
  text: string;
  media?: MediaType[] | null;
  tables?: TableContentType[];
};

export function ManagementComment({ text, media, tables }: Props): JSX.Element {
  const { hasBreakPage } = useSmartGuides();
  const hasTable = tables?.length && tables.length > 0;

  return (
    <StyledManagementComment hasBreakPage={!!hasBreakPage}>
      <PreprInnerHtml text={text} />
      {media && <Media media={media} />}
      {hasTable && <Table tables={tables} />}
    </StyledManagementComment>
  );
}
